import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';
import { withTranslation } from 'react-i18next';

import { DEVICE, PUBLIC_URL } from '../../../config';
import { getCurrentInterfaceLanguage } from '../../../contexts/LanguageContext';

const Meta = ({
  notificationCount = 0,
  title = '',
  language = 'en',
  t,
}) => {
  const currentLanguage = getCurrentInterfaceLanguage();
  const websiteTitle = t('Brickfilms.com by Brick à Brack');
  const defaultTitle = t('LEGO® Stop-motion animation videos & movies');
  const notifText = notificationCount > 0 && notificationCount <= 99 ? `(${notificationCount}) ` : notificationCount > 99 ? `(99+) ` : '';

  // PWA notifications count
  useEffect(() => {
    try {
      if (notificationCount > 0) {
        navigator.setAppBadge(notificationCount);
      } else {
        navigator.clearAppBadge();
      }
    } catch (err) {} // eslint-disable-line no-empty
  }, [notificationCount]);

  // Compute title (Differencies between WEB and PWA)
  let computedTitle = '';
  if (DEVICE === 'WEB') {
    computedTitle += notifText;
  }
  computedTitle += title || defaultTitle;
  if (DEVICE === 'WEB') {
    computedTitle += ` | ${websiteTitle}`;
  }

  return (
    <Helmet defer={false} htmlAttributes={{ lang: language || currentLanguage }}>
      <title>{computedTitle}</title>
      <link rel="shortcut icon" href={`${PUBLIC_URL}${notificationCount > 0 ? 'favicon_active.ico' : 'favicon.ico'}`} type="image/x-icon" />
      <link rel="icon" href={`${PUBLIC_URL}${notificationCount > 0 ? 'favicon_active.svg' : 'favicon.svg'}`} type="image/svg+xml"></link>
    </Helmet>
  );
};

export default withTranslation()(Meta);
